$ = jQuery.noConflict()

$(document).ready(function () {
  function buildThresholdList() {
    var thresholds = []

    for (var i = 1.0; i <= 1.0; i++) {
      var ratio = i / 1.0
      thresholds.push(ratio)
    }

    thresholds.push(0)
    return thresholds
  }

  function createObserver(element) {
    var observer

    var options = {
      root: null,
      rootMargin: '0px',
      threshold: buildThresholdList(),
    }
    observer = new IntersectionObserver(handleIntersect, options)
    element && observer.observe(element)
  }

  function handleIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.target === document.querySelector('.about-us__counters') && entry.intersectionRatio >= 0.5 && !localStorage.getItem('viewNumbers')) {
        localStorage.setItem('viewNumbers', true)
        $('.about-us__count__animated').each(function () {
          $(this)
            .prop('Counter', 0)
            .animate(
              {
                Counter: $(this).text(),
              },
              {
                duration: 2500,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now))
                },
              }
            )
        })
      } else if (entry.target === document.querySelector('#valuesBrand') && entry.intersectionRatio >= 0.5 && !localStorage.getItem('valuesBrand')) {
        setTimeout(function () {
          const title = $('.steps-values__item__marketing').data('title')
          $('.steps-values__item__marketing').addClass('active')
          $('.titleSteps').removeClass('fade-in-fwd')
          $('.titleSteps').addClass('scale-in-center')
          $('.titleSteps').text(title)
        }, 2000)
      }
    })
  }

  if (document.getElementById('valuesBrand')) {
    createObserver(document.getElementById('valuesBrand'))
  }
  if (document.getElementsByClassName('about-us__counters')[0]) {
    createObserver(document.getElementById('valuesBrand'))
    createObserver(document.getElementsByClassName('about-us__counters')[0])
  }
})

